import React from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { FourOhFour } from 'ae-components/four-oh-four/four-oh-four';

import ErrorPage, { linkCss } from '../error/error.page';

const NotFoundPageV2 = () => {
  const { t } = useTranslation('pageNotFound');
  const title = t('titleV2');

  return (
    <ErrorPage
      data-testid="not-found-page"
      backgroundImage="url(/images/404.png)"
      Icon={<FourOhFour />}
      title={title}
    >
      <Trans
        t={t}
        i18nKey="contentV2"
        components={[<Link to="/" css={linkCss} />]}
      />
    </ErrorPage>
  );
};

export default NotFoundPageV2;
